<template>
  <div  class="nuttrema-layout-west-three-vertical">
    <div class="nuttrema-layout-west-three-vertical__top" v-if="checkSlots(['top', 'top-left', 'top-center', 'top-right'])">
      <slot name="top">
        <div class="top--left">
          <slot name="top-left"></slot>
        </div>
        <div class="top--center">
          <slot name="top-center"></slot>
        </div>
        <div class="top--right">
          <slot name="top-right"></slot>
        </div>
      </slot>
    </div>
    <div v-if="checkSlots('center')" class="nuttrema-layout-west-three-vertical__center">
      <div class="center-content" ref="ref-id-nlwtv-center-content">
        <slot name="center"></slot>
      </div>
    </div>
    <div v-if="checkSlots(['bottom-left', 'bottom-center', 'bottom-right'])" class="nuttrema-layout-west-three-vertical__bottom">
      <div class="bottom--left">
        <slot name="bottom-left"></slot>
      </div>
      <div class="bottom--center">
        <slot name="bottom-center"></slot>
      </div>
      <div class="bottom--right">
        <slot name="bottom-right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { has, isArray, each } from 'lodash';

export default {
  name: 'nuttrema-layout-west-three-vertical',
  componentName: 'NuttremaLayoutWestThreeVertical',
  methods: {
    isSlotPresent(slot) {
      return has(this.$slots, slot) && this.$slots[slot][0].tag !== undefined;
    },
    checkSlots(slots) {
      if (isArray(slots)) {
        let count = 0;
        each(slots, (slot) => {
          count += this.isSlotPresent(slot) ? 1 : 0;
        });
        return count > 0;
      }

      return this.isSlotPresent(slots);
    },
    scrollContent(target) {
      const centerContent = this.$refs['ref-id-nlwtv-center-content'];
      const anchor = centerContent.querySelector(`[id=${target}]`);
      if (centerContent && anchor) {
        const topPos = anchor.offsetTop;
        centerContent.scrollTop = topPos - 10;
      }
    },
  },
  created() {
    this.$on('scrollContent', (target) => {
      this.scrollContent(target);
    });
  },
};
</script>

<style lang="scss">
  @import "~styles/theme/colors";
  .nuttrema-layout-west-three-vertical {
    flex-grow: 1;
    height: 100%;
    display: flex;
    align-self: stretch;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;

    .nuttrema-layout-west-three-vertical__top {
      flex-grow: 0;
      display: flex;
      align-self: stretch;
      justify-content: space-between;

      min-height: 3rem;
      border-bottom: 2px solid #DBE2EF;

      .top--left, .top--right {
        display: flex;
        flex-shrink: 0;
        min-width: 3em;
        align-self: stretch;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .top--left__link, .top--right__link {
          display: flex;
          > a, > a:hover {
            color: $gray;
          }
        }
        .top--left__link {
          > .el-button--text {
            margin-left: 0.75em;
          }
        }
        .top--right__link {
          > .el-button--text {
            margin-right: 0.75em;
          }
        }
      }

      .top--center {
        flex-grow: 1;
        flex-shrink: 0;
        align-self: stretch;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .top--center__title {
          flex-grow: 1;
          display: flex;
          position: relative;
          align-self: stretch;
          > span {
            font-weight: 600;
            overflow: hidden;
            line-height: 3rem;
            text-align: center;
            position: absolute;
            white-space: nowrap;
            text-overflow: ellipsis;
            top: 0; left: 0; bottom: 0; right: 0;
          }
        }
      }
    }

    .nuttrema-layout-west-three-vertical__center {
      flex-grow: 1;
      height: 100%;
      display: flex;
      overflow: hidden;
      align-self: stretch;
      justify-content: flex-start;
      background-color: rgba(#DBE2EF, 0.25);

      @supports (-moz-appearance:none) {
        overflow-y: auto;
      }

      .center-content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;

        min-width: 0;
        min-height: 0;
        overflow-y: auto;
        position: relative;
      }
    }

    .nuttrema-layout-west-three-vertical__bottom {
      display: flex;
      flex-shrink: 0;
      min-height: 3rem;
      padding: 0 0.75em;
      align-self: stretch;
      border-top: 2px solid #DBE2EF;
      .bottom--left, .bottom-center, .bottom--right {
        display: flex;
        flex-shrink: 0;
        align-self: stretch;
        align-items: center;
        justify-content: flex-start;
      }
      .bottom--left {
        flex-grow: 1;
      }
      .bottom--center {
        justify-content: center;
      }
      .bottom--right {
        justify-content: flex-end;
      }
    }

    &.is-top-header {
      .nuttrema-layout-west-three-vertical__top {
        flex-shrink: 0;
        border-bottom: none;
        flex-direction: column;
      }
      .nuttrema-layout-west-three-vertical__center {
        flex-shrink: 0;
      }
    }

    &.is-dark {
      .nuttrema-layout-west-three-vertical__top {
        border-bottom: none;
        .top--center {
          color: #fff;
        }
      }
      .nuttrema-layout-west-three-vertical__center {
        background-color: rgba(0,0,0, 1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-west-three-vertical.vue